import React, { useEffect, useState } from "react";
import { Card, Paragraph, Text } from "theme-ui";
import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { InfoIcon } from "../../InfoIcon";
import { useLiquity } from "../../../hooks/LiquityContext";
import { Badge } from "../../Badge";
import { fetchPrices } from "../context/fetchPrices";
import { reservesAndSupply } from "../../Farm/context/fetchPrices";

const selector = ({
  remainingLiquidityMiningLQTYReward2,
  totalStakedUniTokens2,
  price
}: LiquityStoreState) => ({
  remainingLiquidityMiningLQTYReward2,
  totalStakedUniTokens2,
  price
});

export const Yield: React.FC = () => {
  const {
    liquity: {
      connection: { addresses, liquidityMiningLQTYRewardRate }
    }
  } = useLiquity();

  const { remainingLiquidityMiningLQTYReward2, totalStakedUniTokens2, price } = useLiquitySelector(selector);
  const [lqtyPrice, setLqtyPrice] = useState<Decimal | undefined>(undefined);
  const [uniLpPrice, setUniLpPrice] = useState<Decimal | undefined>(undefined);
  const hasZeroValue = remainingLiquidityMiningLQTYReward2.isZero || totalStakedUniTokens2.isZero;
  const lqtyTokenAddress = addresses["lqtyToken"];
  const uniTokenAddress = addresses["uniToken2"];
  const secondsRemaining = remainingLiquidityMiningLQTYReward2.div(liquidityMiningLQTYRewardRate);
  const daysRemaining = secondsRemaining.div(60 * 60 * 24);

  useEffect(() => {
    (async () => {
      try {
        const tokensPrice = JSON.parse(localStorage.getItem('tokensPrice') || '{}');
        const earnPrice = tokensPrice.PRINT || 0;

        const { reservesData, totalSupply } = await reservesAndSupply(uniTokenAddress);
        let totalSupply1 = Number(totalSupply)/1e18;
        let reservesData1 = reservesData;
        let reserve0 = Number(reservesData1[0])/1e18
        let reserve1 = Number(reservesData1[1])/1e18

        const LpPrice = (reserve0 * Number(price) + reserve1 * earnPrice) / totalSupply1;

        setLqtyPrice(Decimal.from(earnPrice));
        setUniLpPrice(Decimal.from(LpPrice));
      } catch (error) {
        console.error(error);
      }
    })();
  }, [lqtyTokenAddress, uniTokenAddress]);

  if (hasZeroValue || lqtyPrice === undefined || uniLpPrice === undefined) return null;

  const remainingLqtyInUSD = remainingLiquidityMiningLQTYReward2.mul(lqtyPrice);
  const totalStakedUniLpInUSD = totalStakedUniTokens2.mul(uniLpPrice);
  const yieldPercentage = remainingLqtyInUSD.div(totalStakedUniLpInUSD).mul(100);

  if (yieldPercentage.isZero) return null;

  return (
    <Badge>
      <br/>
      <Text>
        {daysRemaining?.prettify(0)} day yield {yieldPercentage.toString(2)}%
      </Text>
      <InfoIcon
        tooltip={
          <Card variant="tooltip" sx={{ minWidth: ["auto", "352px"] }}>
            <Paragraph>
              An <Text sx={{ fontWeight: "bold" }}>estimate</Text> of the PRINT return on staked PulseX
              LP tokens. The farm runs for 369 days, and the return is relative to the time remaining.
            </Paragraph>
            <Paragraph sx={{ fontSize: "12px", fontFamily: "monospace", mt: 2 }}>
              ($PRINT_REWARDS / $STAKED_PulseX_LP) * 100 ={" "}
              <Text sx={{ fontWeight: "bold" }}> Yield</Text>
            </Paragraph>
            <Paragraph sx={{ fontSize: "12px", fontFamily: "monospace" }}>
              ($
              {remainingLqtyInUSD.shorten()} / ${totalStakedUniLpInUSD.shorten()}) * 100 =
              <Text sx={{ fontWeight: "bold" }}> {yieldPercentage.toString(2)}%</Text>
            </Paragraph>
          </Card>
        }
      ></InfoIcon>
    </Badge>
  );
};